<p-avatar [image]="avatar"
          [styleClass]="styleClass"
          [shape]="shape"
          [label]="initials"
          [size]="size">
</p-avatar>
